<template>
	<section>
		<el-col style="padding-top: 80px;">
			<el-form :inline="true">
				<el-form-item>
					<!--列表-->
					<el-table :data="addForm.goodsList" highlight-current-row style="width: 100%;">
						<el-table-column type="index" width="50">
						</el-table-column>
						<el-table-column prop="barCode" label="条形码" width="200">
						</el-table-column>
						<el-table-column prop="name" label="名称" width="150">
						</el-table-column>
						<el-table-column prop="brand" label="品牌" width="80">
						</el-table-column>
						<el-table-column prop="form" label="规格" width="250">
						</el-table-column>
						<el-table-column prop="unit" label="单位" width="80">
						</el-table-column>
						<el-table-column v-if="addForm.demanderId" prop="advicePrice" label="历史价" width="80">
							<template scope="scope">
								<span v-if="scope.row.advicePrice!='无'" style="color: red">{{scope.row.advicePrice}}</span>
								<span v-if="scope.row.advicePrice=='无'">{{scope.row.advicePrice}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="price" label="单价" width="160">
							<template scope="scope">
								<el-input-number controls-position="right" size="mini" :maxlength="10" :key="scope.row.id" :value="scope.row.price" @input="handleGoodsPriceChange(scope.$index, scope.row, $event)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="count" label="数量" width="160">
							<template scope="scope">
								<el-input-number controls-position="right" size="mini" :maxlength="10" :value="scope.row.count" :key="scope.row.id" @change="handleGoodsCountChange(scope.$index, scope.row, $event)" ></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="" label="合计金额" width="100">
							<template scope="scope">
								{{(scope.row.count*1000)*(scope.row.price*1000)/1000000}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="150">
							<template scope="scope">
								<el-button size="small" type="danger" icon="el-icon-delete" @click="handleDel(scope.$index, scope.row)"></el-button>
								<el-tooltip  v-if="isAdmin" class="item" effect="dark" :content="scope.row.bidPrice+''" placement="right">
									<el-button size="mini" icon="el-icon-paperclip"></el-button>
								</el-tooltip>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
				<br>
				<el-form-item label="总数量">
					<span><b>{{addForm.count}}</b> &nbsp;件</span>
				</el-form-item>
				<el-form-item label="总金额" prop="sum">
					<span><b>{{addForm.sum}}</b> &nbsp;RMB</span>
				</el-form-item>
				<el-button type="warning" @click.native="handleAdd">开单</el-button>
			</el-form>
		</el-col>
		
		<!--工具条-->
		<el-col :span="24" class="r" >
			<el-form :inline="true" :model="addForm" ref="addForm" >
				<el-form-item>
					<el-autocomplete
				      class="inline-input select-option"
				      v-model="filters.name"
				      @input="handleKeyPress"
				      @keyup.enter.native="handleEnter"
				      :fetch-suggestions="querySearch"
				      :trigger-on-focus="false"  
				      placeholder="按条形码、名称或拼音首字母搜索"
				      @select="((item)=>handleSelect(item))"
				  >
				  <el-button slot="append" v-on:click="handleGoodsAdd" icon="el-icon-circle-plus"></el-button>
				</el-autocomplete>
				  <!-- <el-autocomplete
				      class="inline-input select-option"
				      v-if="!ischeck"
				      v-model="filters.name"
				      @input="getGoods"
				      @keyup.enter.native="handleEnter"
				      :fetch-suggestions="querySearch"
				      :trigger-on-focus="false"  
				      placeholder="按条形码、名称或拼音首字母搜索"
				      @select="((item)=>handleSelect(item))"
				  >
				  <el-button slot="append" v-on:click="handleGoodsAdd" icon="el-icon-circle-plus"></el-button>
				</el-autocomplete>
				<el-autocomplete
				      class="inline-input select-option"
				      v-if="ischeck"
				      v-model="filters.name"
				      @input="getAdviceGoods"
				      @keyup.enter.native="handleEnter"
				      :fetch-suggestions="querySearch"
				      :trigger-on-focus="false"  
				      placeholder="按条形码、名称或拼音首字母搜索"
				      @select="((item)=>handleSelect(item))"
				  >
				  <el-button slot="append" v-on:click="handleGoodsAdd" icon="el-icon-circle-plus"></el-button>
				</el-autocomplete> -->
				</el-form-item>
				<el-form-item prop="providerId">
					<el-select v-model="addForm.providerId" filterable placeholder="销售公司" clearable>
					    <el-option
					      v-for="item in providers"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
				  	</el-select>
				</el-form-item>
				<el-form-item prop="demanderId">
					<el-select v-model="addForm.demanderId" filterable placeholder="需求公司" @change="handleDemanderChange" clearable>
					    <el-option
					      v-for="item in demanders"
					      :key="item.id"
					      :label="item.name+item.contacter+item.phone"
					      :value="item.id">
					    </el-option>
				  	</el-select>
				</el-form-item>
				<el-form-item>
					<i v-on:click="handleDemanderAdd" class="fa fa-user-plus"></i>
				</el-form-item>
				
			</el-form>
		</el-col>

		<!--结账界面-->
		<el-dialog title="开单" :visible.sync="paymentVisible" :close-on-click-modal="false" >
			<el-form :model="addForm" label-width="80px" ref="addForm">
				<el-form-item label="总数量">
					<span><b>{{addForm.count}}</b> &nbsp;件</span>
				</el-form-item>
				<el-form-item label="应收" prop="sum">
					<span><b>{{addForm.sum}}</b> &nbsp;元</span>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input type="textarea" v-model="addForm.remark" clearable></el-input>
				</el-form-item>
				<el-form-item label="付款方式" prop="payway">
					<el-radio v-model="addForm.payway" label="1">支付宝
				    </el-radio>
				    <el-radio v-model="addForm.payway" label="2">微信
				    </el-radio>
				    <el-radio v-model="addForm.payway" label="3">现金
				    </el-radio>
				    <el-radio v-model="addForm.payway" label="4">记账
				    </el-radio>
				    <el-radio v-model="addForm.payway" label="5">POS
				    </el-radio>
				</el-form-item>
				<el-form-item label="实收" v-if="addForm.payway==3">
					<el-input v-model="received" clearable></el-input>
				</el-form-item>
				<el-form-item label="找零" v-if="addForm.payway==3">
					<span><b>{{received-addForm.sum}}</b> &nbsp;元</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="paymentVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :disabled="!addForm.payway" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增需求公司界面-->
		<el-dialog title="新增需求公司" :visible.sync="addDemanderFormVisible" :close-on-click-modal="false">
			<el-form :model="addDemanderForm" label-width="80px" :rules="addDemanderFormRules" ref="addDemanderForm">
				<el-form-item label="公司名" prop="name">
					<el-input v-model="addDemanderForm.name"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="contacter">
					<el-input v-model="addDemanderForm.contacter"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="phone">
					<el-input v-model="addDemanderForm.phone" :maxlength="11"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addDemanderFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addDemanderSubmit" :loading="addDemanderLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增商品界面-->
		<el-dialog title="新增商品" :visible.sync="addGoodsFormVisible" :close-on-click-modal="false">
			<el-form :model="addGoodsForm" label-width="80px" :rules="addGoodsFormRules" ref="addGoodsForm">
				<el-form-item label="条形码" prop="barCode">
					<el-input v-model="addGoodsForm.barCode"></el-input>
				</el-form-item>
				<el-form-item label="名称" prop="name">
					<el-input v-model="addGoodsForm.name" @input="getFirstLetter"></el-input>
				</el-form-item>
				<el-form-item label="大写" prop="firstLetter">
					<el-input v-model="addGoodsForm.firstLetter"></el-input>
				</el-form-item>
				<el-form-item label="品牌" prop="brand">
					<el-input v-model="addGoodsForm.brand"></el-input>
				</el-form-item>
				<el-form-item label="规格" prop="form">
					<el-input v-model="addGoodsForm.form"></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="unit">
					<el-input v-model="addGoodsForm.unit"></el-input>
				</el-form-item>
				<el-form-item label="价格" prop="price">
					<el-input type="number" v-model="addGoodsForm.price" :min="0" :max="99999"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addGoodsFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addGoodsSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import { getGoodsList, addOrder, getDemanderList, getProviderList, addDemander, addGoods, getGoodsPriceAdvice, getGoodsPriceAdviceList} from '../../api/api';
	import Cookies from 'js-cookie'
	import _ from 'lodash';
	import '../../common/js/pinyinUtil.js'
	import util from '../../common/js/util'
	import Vue from 'vue'

	export default {
		data() {
			return {
				isAdmin: Cookies.get('user_type')==1,
				filters: {
					name: '',
					form: '',
					brand: ''
				},
				goods: [],
				adviceGoods: [],

				//收银界面数据
				addForm: {
					sum: 0,
					count: 0,
					goodsList: [],
					payway:'',
					providerId:'',
					demanderId:'',
					remark:''
				},

				received: 0,

				//销售公司
				providers: [],
				//需求公司
				demanders: [],

				paymentVisible:false,
				addLoading:false,


				//需求公司新增
				addDemanderFormVisible: false,//新增界面是否显示
				addDemanderLoading: false,
				addDemanderFormRules: {
					contacter: [
						{ required: true, message: '请输入联系人', trigger: 'blur' }
					],
					phone: [
						{ required: true, message: '请输入联系电话', trigger: 'blur' }
					]
				},
				addDemanderForm: {
				},

				//商品新增
				addGoodsForm:{
				},
				addGoodsFormVisible:false,
				addGoodsFormRules: {
					name: [
						{ required: true, message: '请输入商品名称', trigger: 'blur' }
					],
					unit: [
						{ required: true, message: '请输入单位', trigger: 'blur' }
					]
				},

				// 初始化一个debounce函数
      			handleKeyPress:_.debounce(this.getAllGoods, 100) // 500毫秒内只触发一次

			}
		},
		methods: {
			//处理筛选内容
			querySearch(queryString,cb){
				this.ccb = cb;
				let arr = [];
				this.goods.forEach((item,index) => {
					let advicePrice = '';
					this.adviceGoods.forEach((item1,index1) => {
						if(item1.id==item.id){
							advicePrice = ' => 历史价：' + item1.price;
						}
					});
					item.value = item.brand+item.form+item.name+'_'+item.price+'元/'+item.unit+advicePrice;
					if(advicePrice!=''){
						arr.unshift(item);
					}else{
						arr.push(item);
					}
				});
			    cb(arr)
			},
			//处理物料价格
			handleGoodsPriceChange: function(index, row, e){
				let oldPrice = row.price;
				row.price = Number(e);
				this.addForm.sum = util.formatNumber(this.addForm.sum + (row.price - oldPrice)*row.count);
			},
			//处理物料数量
			handleGoodsCountChange: function(index, row, e){
				let oldCount = row.count;
				row.count = Number(e);
				this.addForm.count = util.formatNumber(this.addForm.count + row.count - oldCount);
				this.addForm.sum = util.formatNumber(this.addForm.sum + (row.count - oldCount)*row.price);
			},
			//处理需求公司变化
			handleDemanderChange(){
				if(this.addForm.demanderId){
					this.addForm.goodsList.forEach((goods,i) => {
						let para = {
							goodsId:goods.id,
		                    demanderId:this.addForm.demanderId
						};
						getGoodsPriceAdvice(para).then((res) => {
							let msg = res.data.message;
		                	let code = res.data.code;
							if (code !== 200) {
			                  this.$message({
			                    message: msg,
			                    type: 'error'
			                  });
			                } else {
			                	if(res.data.data){
			                		this.addForm.goodsList[i].advicePrice=res.data.data
			                	}else{
			                		this.addForm.goodsList[i].advicePrice='无';	
			                	}
			                	Vue.set(this.addForm.goodsList,i,this.addForm.goodsList[i]);
							}
						});
					});

				}
			},
			//处理开关变化
			handleSwitchChange: function(index, row, e){
				let oldCount = row.count;
				row.count = Number(e);
				this.addForm.count = util.formatNumber(this.addForm.count + row.count - oldCount);
				this.addForm.sum = util.formatNumber(this.addForm.sum + (row.count - oldCount)*row.price);
			},
			//处理选择
			handleSelect(item){
				item.count = 1;
				if(this.addForm.demanderId){
					let para = {
						goodsId:item.id,
	                    demanderId:this.addForm.demanderId
					};
					getGoodsPriceAdvice(para).then((res) => {
						let msg = res.data.message;
	                	let code = res.data.code;
						if (code !== 200) {
		                  this.$message({
		                    message: msg,
		                    type: 'error'
		                  });
		                } else {
		                	if(res.data.data){
		                		item.advicePrice=res.data.data
		                	}else{
		                		item.advicePrice='无';	
		                	}
		                	this.addForm.goodsList.push(item);
						}
					});
				}else{
					this.addForm.goodsList.push(item);
				}
				this.filters.name = '';
				this.addForm.count += util.formatNumber(item.count);
				this.addForm.sum = util.formatNumber(this.addForm.sum + item.count*item.price);
				this.goods=[];
			},
			//处理回车
			handleEnter(){
				this.filters.name = '';
				if(this.goods.length>0){
					this.handleSelect(this.goods[0]);
				}
			},
			//获取首字母
			getFirstLetter:function(){
				this.addGoodsForm.firstLetter = pinyinUtil.getFirstLetter(this.addGoodsForm.name);
			},
			//显示新增商品界面
			handleGoodsAdd: function () {
				this.addGoodsFormVisible = true;
				this.addGoodsForm = {
					barCode: '',
					name: '',
					firstLetter: '',
					brand: '',
					form: '',
					unit: '',
					price: 0,
				};
			},
			//新增商品
			addGoodsSubmit: function () {
				this.$refs.addGoodsForm.validate((valid) => {
					if (valid) {
						this.addLoading = true;
						let para = Object.assign({}, this.addGoodsForm);
						addGoods(para).then((res) => {
							this.addLoading = false;
							this.addGoodsFormVisible = false;
							let msg = res.data.message;
		                	let code = res.data.code;
							if (code !== 200) {
			                  this.$message({
			                    message: msg,
			                    type: 'error'
			                  });
			                } else {
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								let goods = res.data.data;
								goods.advicePrice='无';	
								goods.count=1;
								this.addForm.goodsList.push(goods);
								this.addForm.count += util.formatNumber(goods.count);
								this.addForm.sum = util.formatNumber(this.addForm.sum + goods.count*goods.price);
								this.$refs['addGoodsForm'].resetFields();
							}
						});
					}
				});
			},
			//删除
			handleDel: function (index, row) {
				this.addForm.goodsList.splice(index,1);
				this.addForm.count = util.formatNumber(this.addForm.count - row.count);
				this.addForm.sum = util.formatNumber(this.addForm.sum - row.count*row.price);
			},
			//处理结账
			handleAdd(){
				// if(this.addForm.demanderId==''){
				// 	this.$message({
			 //            message: '请选择需求公司',
			 //            type: 'error'
			 //          });
				// }else if(this.addForm.providerId==''){
				// 	this.$message({
			 //            message: '请选择销售公司',
			 //            type: 'error'
			 //          });
				// }else{
					this.addForm.payway = '4';
					this.paymentVisible = true;
					this.received = this.addForm.sum;
				// }
			},
			//结账
			addSubmit: function () {
				this.addLoading = true;
				addOrder(this.addForm).then((res) => {
					this.addLoading = false;
					this.paymentVisible = false;
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.$refs['addForm'].resetFields();
						this.addForm.goodsList = [];
						this.addForm.sum = 0;
						this.addForm.count = 0;
						this.goOrderView();
					}
				});
			},
			//获取所有物料
			getAllGoods(){
				this.getGoods();
				if(this.addForm.demanderId){
					this.getAdviceGoods();
				}
			},
			//获取物料列表
			getGoods() {
				let para = {
					page:1,
                    size:200,
                    name:this.filters.name,
                    form:this.filters.form,
                    brand:this.filters.brand
				};
				getGoodsList(para).then((res) => {
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.goods = res.data.data.list
	                }
				});
			},
			//获取需求公司商品列表
			getAdviceGoods() {
				let para = {
					page:1,
                    size:200,
                    name:this.filters.name,
                    demanderId:this.addForm.demanderId
				};
				getGoodsPriceAdviceList(para).then((res) => {
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.adviceGoods = res.data.data.list
	                }
				});
			},
			
			//获取销售公司列表
			getProviders() {
				let para = {
				};
				getProviderList(para).then((res) => {
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.providers = res.data.data.list
	                }
				});
			},
			//获取需求公司列表
			getDemanders() {
				let para = {
                    role:2
				};
				getDemanderList(para).then((res) => {
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.demanders = res.data.data.list
	                }
				});
			},
			//显示需求公司新增界面
			handleDemanderAdd: function () {
				this.addDemanderFormVisible = true;
				this.addDemanderForm = {
					role: 2,
					name: '',
					contacter: '',
					phone: ''
				};
			},
			//新增
			addDemanderSubmit: function () {
				this.$refs.addDemanderForm.validate((valid) => {
					if (valid) {
						this.addDemanderLoading = true;
						let para = Object.assign({}, this.addDemanderForm);
						addDemander(para).then((res) => {
							this.addDemanderLoading = false;
							this.addDemanderFormVisible = false;
							let msg = res.data.message;
		                	let code = res.data.code;
							if (code !== 200) {
			                  this.$message({
			                    message: msg,
			                    type: 'error'
			                  });
			                } else {
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['addDemanderForm'].resetFields();
								this.getDemanders();
							}
						});
					}
				});
			},

			//跳转订单列表页面
			goOrderView: function () {
				this.$router.push({path: '/order/list'});
			},
		},
		mounted() {
			this.getAllGoods();
			this.getDemanders();
			this.getProviders();
			let res = this.$route.params.relatedResponse || this.$route.query.relatedResponse;
			if(res == undefined){
			}else{
				this.addForm = JSON.parse(res)
			}
		},
	}

</script>

<style scoped>
	i:hover{ 
		color:#999;
		cursor: pointer;
	}

 .avatar-uploader{
 	width: 178px;
    height: 178px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .signImg {
    width: 50px;
    height: 80px;
  }
  .el-upload {
  	margin-left: 25px;
  }
  img{
  	width:100%;
  	height:100%;
  }
  .el-autocomplete-suggestion{
  		width: 300px;
  	
  }
  .r{
  	position:fixed; 
  	top:120px;
  	padding-left: 20px;
  	padding-top: 5px;
  	padding-bottom: 5px;
  }
  .select-option{
  	width: 600px;
  }

</style>

<style media="print">
    @page {
        size: auto;  /* auto is the initial value */
        margin: 0mm; /* this affects the margin in the printer settings */
    }
</style>

